import { render, staticRenderFns } from "./JobDetailsView.vue?vue&type=template&id=1840ea14&scoped=true&lang=pug&"
import script from "./JobDetailsView.vue?vue&type=script&lang=ts&"
export * from "./JobDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./JobDetailsView.vue?vue&type=style&index=0&id=1840ea14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840ea14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1840ea14')) {
      api.createRecord('1840ea14', component.options)
    } else {
      api.reload('1840ea14', component.options)
    }
    module.hot.accept("./JobDetailsView.vue?vue&type=template&id=1840ea14&scoped=true&lang=pug&", function () {
      api.rerender('1840ea14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/job-components/JobDetailsView.vue"
export default component.exports